import { Outlet } from "react-router-dom";

import './Layout.css';
import Header from "../components/header/Header";
import Alerts from "../components/alerts/Alerts";
import Footer from "../components/footer/Footer";

export default function Layout() {
    return (
        <>
            <div className='layout-container'>
                <Header />
                <main>
                    <Alerts />
                    <Outlet />
                </main>
            </div>
            <Footer />
        </>
    );
}